var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.502,
    height: 30.001,
    viewBox: "0 0 22.502 30.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bookmark",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39789",
    "data-name": "Path 39789",
    d: "M25.5,27.842V3.383A3.378,3.378,0,0,0,22.138,0H6.364A3.378,3.378,0,0,0,3,3.383V27.84A2.15,2.15,0,0,0,6.394,29.6l7.7-5.479a.271.271,0,0,1,.313,0l7.7,5.479A2.15,2.15,0,0,0,25.5,27.842Zm-1.875,0a.276.276,0,0,1-.153.255.258.258,0,0,1-.28-.021l-7.7-5.479a2.145,2.145,0,0,0-2.485,0l-7.7,5.479a.26.26,0,0,1-.28.021.277.277,0,0,1-.153-.255V3.383A1.5,1.5,0,0,1,6.364,1.875H22.137a1.5,1.5,0,0,1,1.489,1.508V27.842Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39790",
    "data-name": "Path 39790",
    d: "M13.751,6.306l-.251.266-.251-.266a4.209,4.209,0,0,0-6.027,0,4.586,4.586,0,0,0,0,6.223l5.6,5.921a.94.94,0,0,0,1.363,0l5.6-5.921a4.586,4.586,0,0,0,0-6.223,4.207,4.207,0,0,0-6.027,0Zm4.664,4.933L13.5,16.44l-4.915-5.2a2.686,2.686,0,0,1,0-3.644,2.234,2.234,0,0,1,3.3,0l.933.986a.968.968,0,0,0,1.363,0l.933-.986a2.285,2.285,0,0,1,3.3,0A2.686,2.686,0,0,1,18.415,11.239Z",
    transform: "translate(0.752 1.259)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.7399252ba72a68e8dd2315d242092fe2.svg";
export { ForwardRef as ReactComponent };